import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logoutSuccess } from '../../../redux/reducers/Auth';
import { getPAIAH010, postLogout, postPAIAH030 } from '../../../services/Api';
import SideNav from '../../../shared/components/SideNav';
import { decodeToken, handleFocus } from '../../../utils';

const PAIAH030 = () => {
    const navigate = useNavigate();
    const [password, setPassword] = useState('');
    const [reason, setReason] = useState('');
    const token = useSelector(({ auth }) => auth.login.token);
    const [info, setInfo] = useState({});
    const dispatch = useDispatch();

    useEffect(() => {
        setInfo(decodeToken(token));
        // eslint-disable-next-line
    }, [token]);

    const handleInputChange = (e) => {
        const { value, name } = e.target;
        if (name === 'password') {
            setPassword(value);
        } else if (name === 'reason') {
            setReason(value);
        }
    };

    const handleSave = async () => {
        if (!password || !reason) {
            if (!password) {
                window.alert('비밀번호를 입력해 주세요.');
                handleFocus('password');
            } else if (!reason) {
                window.alert('탈퇴 이유를 입력해 주세요.');
                handleFocus('reason');
            }
            return;
        } else if (reason.length > 200) {
            window.alert('탈퇴이유 최대 200 글자까지만 입력이 가능합니다.');
            handleFocus('reason');
            return;
        }
        const response = await getPAIAH010(password);
        if (response?.data === false) {
            window.alert('등록된 아이디와 비밀번호가 일치하지 않습니다.');
            handleFocus('password');
            return;
        }

        const payload = {
            password,
            reason,
        };

        const confirmSubmit = window.confirm('덴탈잡 회원탈퇴를 하시겠습니까?');
        if (confirmSubmit) {
            try {
                await postPAIAH030(payload);
                window.alert('탈퇴가 완료되었습니다.\n더 나은 서비스로 찾아뵙도록 하겠습니다.');

                const response = await postLogout();
                if (response.status === 200) {
                    sessionStorage.removeItem('authPassVerified');
                    localStorage.removeItem('savedPAEAA010Conditions');
                    localStorage.removeItem('savedPAFAA010Conditions');
                    dispatch(logoutSuccess());
                    navigate('/');
                }
            } catch (error) {
                console.log(error);
            }
        }
    };

    return (
        <div id="content" className="sub-page">
            <div className="container">
                <div id="top-sub-page">
                    <SideNav />
                    <div className="resume">
                        <div className="resume__inner">
                            <h3 className="resume__tit">회원탈퇴</h3>
                            <div className="mdf">
                                <h4 className="mdf__tit">탈퇴 관련 안내</h4>
                                <div className="mdf__container2">
                                    <div className="mdf__notice">
                                        <i>•</i>
                                        <span>
                                            탈퇴시에는 <b>덴탈잡, 덴탈비타민, 덴탈세미나, DVmall</b> 사이트의 이용내역이
                                            삭제되며, 이용이 불가능합니다.
                                        </span>
                                    </div>
                                    <div className="mdf__notice">
                                        <i>•</i>
                                        <span>
                                            탈퇴하신 ID는 다시 이용하실 수 없으며,{' '}
                                            <b>보유하신 DV Point는 탈퇴시 소멸처리되어 복원되지 않습니다.</b>
                                        </span>
                                    </div>
                                    <div className="mdf__notice">
                                        <i>•</i>
                                        <span>
                                            재이용을 원하실 경우 신규가입을 하셔야 하며, 이전의 정보는 복원되지
                                            않습니다.
                                        </span>
                                    </div>
                                    <div className="mdf__notice">
                                        <i>•</i>
                                        <span>
                                            <b>덴탈잡 치과회원, 개인회원간의 그룹전환</b>은 탈퇴이전에{' '}
                                            <b>덴탈잡 이메일상담</b> 또는 <b>덴탈잡 고객센터(080-801-1580)</b>에 먼저
                                            문의하시기 바랍니다.
                                        </span>
                                    </div>
                                </div>
                                <div className="mdf__container gap5">
                                    <div className="mdf__grid2">
                                        <div className="mdf__sbj">아이디</div>
                                        <div className="mdf__div mdf__div--flex">
                                            <span className="mdf__blue bold">{info.memberID}</span>
                                        </div>
                                    </div>
                                    <div className="mdf__grid2">
                                        <div className="mdf__sbj pt0">비밀번호</div>
                                        <div className="mdf__div">
                                            <input
                                                type="password"
                                                name="password"
                                                className="mdf__input wd-full"
                                                placeholder="비밀번호를 입력해 주세요"
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="mdf__grid2" style={{ alignItems: 'start' }}>
                                        <div className="mdf__sbj pt0">탈퇴이유</div>
                                        <div className="mdf__div">
                                            <textarea
                                                name="reason"
                                                className="mdf__textarea"
                                                placeholder="탈퇴 이유를 입력해 주세요."
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="mdf__btbx">
                                    <button type="button" className="mdf__btn mdf__btn--red" onClick={handleSave}>
                                        회원탈퇴
                                    </button>
                                    <button type="button" className="mdf__btn" onClick={() => navigate('/paiah020')}>
                                        취소
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PAIAH030;
